import React, { useState } from 'react'
import {Table, Button, Row, Col, Alert, FormControl, InputGroup} from 'react-bootstrap'
import './OpticianList.css'
import SaveOpticianDialog from './SaveOpticianDialog';
import LinkOpticianDialog from './LinkOpticianDialog';
import {Container} from "react-bootstrap";
import {BsExclamationCircleFill, BsLink45Deg, BsPencilSquare, BsPlus, BsSearch} from "react-icons/bs";

const OpticianList = ({
    opticians,
    createDialogOpen,
    updateDialogOpen,
    opticianForm,
    careUnits,
    saveOpticianError,
    loggedInOptician,
    loggedInUserRole,
    addOpticianClicked,
    updateOpticianClicked,
    closeDialogClicked,
    deleteOptician,
    createOptician,
    updateOptician,
    errorMessage,
    isLoading,
    linkDialogOpen,
    linkableOpticians,
    linkError,
    openLinkDialog,
    closeLinkDialog,
    linkOptician,
}) => {

    const [searchTerm, setSearchTerm] = useState('');
    const isCareUnitRole = loggedInUserRole === 'CARE_UNIT_ADMIN' || loggedInUserRole === 'CARE_UNIT';

    const filteredOpticians = (opticians || []).filter(o => {
        if (!searchTerm) return true;
        return o.name?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
    <div className="OpticianList">
        <Container id={"opticianMainGrid"} className="">
            {errorMessage &&
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Alert variant={"danger"}>
                            <b><BsExclamationCircleFill/> {errorMessage}</b>
                        </Alert>
                    </Col>
                </Row>
            }
            <Row>
                <Col xs={12}>
                    <h1>{isCareUnitRole ? 'Kopplade optiker' : 'Optiker'}</h1>
                </Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Col xs={12} sm={6} md={4}>
                    <InputGroup>
                        <InputGroup.Text className="SaveOpticianDialog-input-icon"><BsSearch /></InputGroup.Text>
                        <FormControl
                            type="text"
                            placeholder="Sök på namn..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                </Col>
                <Col xs={12} sm={6} md={8} className="d-flex align-items-end justify-content-end gap-2">
                    {isCareUnitRole && (
                        <Button className="add-button mb-0" onClick={() => openLinkDialog()}><BsLink45Deg/> Koppla befintlig</Button>
                    )}
                    <Button className="add-button mb-0" onClick={() => addOpticianClicked()}><BsPlus/> Lägg till</Button>
                </Col>
            </Row>
        </Container>

        {linkDialogOpen && (
            <LinkOpticianDialog
                linkableOpticians={linkableOpticians}
                linkError={linkError}
                onCancelClicked={closeLinkDialog}
                onLinkClicked={linkOptician}
                isLoading={isLoading}
            />
        )}

        {(updateDialogOpen && (
            <div>
                <SaveOpticianDialog
                    saveErrorMessage={saveOpticianError}
                    onCancelClicked={closeDialogClicked}
                    onUpdateClicked={updateOptician}
                    onDeleteClicked={deleteOptician}
                    opticianForm={opticianForm}
                    careUnits={careUnits}
                    loggedInUserRole={loggedInUserRole}
                    isLoading={isLoading}
                />
            </div>
        )) || (createDialogOpen && (
            <SaveOpticianDialog
                saveErrorMessage={saveOpticianError}
                opticianForm={{}}
                careUnits={careUnits}
                onCancelClicked={closeDialogClicked}
                onSaveClicked={createOptician}
                loggedInUserRole={loggedInUserRole}
                isLoading={isLoading}
            />
        ))}

        <Table size="sm" hover responsive>
            <thead>
            <tr>
                <th>#</th>
                <th>Namn</th>
                <th>Email</th>
                <th>Kontaktperson</th>
                <th>Telefon kontakt</th>
                <th>Gatuadress</th>
                <th>Postnummer</th>
                <th>Stad</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {
                filteredOpticians.map((org, index) =>
                    <tr key={index}>
                        <td>{index+1}</td>
                        <td>{org.name}</td>
                        <td>{org.organizationEmail}</td>
                        <td>{org.contactName}</td>
                        <td>{org.contactPhoneNumber}</td>
                        <td>{org.streetAddress}</td>
                        <td>{org.zipCode}</td>
                        <td>{org.city}</td>
                        <td>
                            <div className={"float-end table-buttons d-flex align-items-center"}>
                                <Button onClick={() => updateOpticianClicked(org)} disabled={org.name===loggedInOptician}><BsPencilSquare/><span> Uppdatera</span></Button>
                            </div>
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>
    </div>)}
export default OpticianList;